"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkedinSquare = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function LinkedinSquare(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09375 3.69922H19.0938C20.1983 3.69922 21.0938 4.59465 21.0938 5.69922V19.6992C21.0938 20.8038 20.1983 21.6992 19.0938 21.6992H5.09375C3.98918 21.6992 3.09375 20.8038 3.09375 19.6992V5.69922C3.09375 4.59465 3.98918 3.69922 5.09375 3.69922ZM8.09375 18.6992C8.36989 18.6992 8.59375 18.4754 8.59375 18.1992V11.1992C8.59375 10.9231 8.36989 10.6992 8.09375 10.6992H6.59375C6.31761 10.6992 6.09375 10.9231 6.09375 11.1992V18.1992C6.09375 18.4754 6.31761 18.6992 6.59375 18.6992H8.09375ZM7.34375 9.69922C6.51532 9.69922 5.84375 9.02765 5.84375 8.19922C5.84375 7.37079 6.51532 6.69922 7.34375 6.69922C8.17218 6.69922 8.84375 7.37079 8.84375 8.19922C8.84375 9.02765 8.17218 9.69922 7.34375 9.69922ZM17.5938 18.6992C17.8699 18.6992 18.0938 18.4754 18.0938 18.1992V13.5992C18.1262 12.01 16.9514 10.6537 15.3738 10.4592C14.2708 10.3585 13.202 10.8736 12.5938 11.7992V11.1992C12.5938 10.9231 12.3699 10.6992 12.0938 10.6992H10.5938C10.3176 10.6992 10.0938 10.9231 10.0938 11.1992V18.1992C10.0938 18.4754 10.3176 18.6992 10.5938 18.6992H12.0938C12.3699 18.6992 12.5938 18.4754 12.5938 18.1992V14.4492C12.5938 13.6208 13.2653 12.9492 14.0938 12.9492C14.9222 12.9492 15.5938 13.6208 15.5938 14.4492V18.1992C15.5938 18.4754 15.8176 18.6992 16.0938 18.6992H17.5938Z",
    fill: "currentColor"
  }));
}

exports.LinkedinSquare = LinkedinSquare;